import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import moment from 'moment';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import Employee from '../js/employee.js';
import AutoNumeric from 'autonumeric';
var Income = {
  pn: 'div[data-name="income"]',
  selectedMonth: null,
  selectedYear: null,
  init: function init() {
    var _this = this;

    Employee.incomeRow = null;
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var $month = $(this.pn + ' select[name="month"]');
    var $year = $(this.pn + ' input[name="year"]');
    $month.val(month);
    $year.val(year);
    $month.change(function (e) {
      if (Employee.currentRow == null) return false;

      _this.getdata();
    });
    $year.change(function (e) {
      if (Employee.currentRow == null) return false;

      _this.getdata();
    });
    $('#income-save-button').click(function (e) {
      if (Employee.currentRow == null) return false;

      _this.save();
    });
    AutoNumeric.multiple(this.pn + ' .autonumeric', Base.autoNumericConfig); //Tính toán lại khi có thay đổi tại bất kỳ trường nào có class là .recalculate

    $(this.pn + ' .recalculate').change(function () {
      //Update dữ liệu của nhân viên hiện tại
      if ($(this).hasClass('autonumeric')) Employee.incomeRow[$(this).attr("name")] = Utils.str2Num($(this).val());else Employee.incomeRow[$(this).attr("name")] = $(this).val(); //Tính toán lại

      Income.calculate();
    }); //Làm trắng form khi bắt đầu vào trang

    this.reset(); //Đăng ký sự kiện chọn nhân viên

    Base.app.off('selectEmpForIncome');
    Base.app.on('selectEmpForIncome', function (data) {
      Employee.currentRow = Employee.rows.find(function (e) {
        return e.id === data.id;
      });
      $(_this.pn + ' .emp-name').text(Employee.currentRow.name);

      _this.getdata();
    }); //Đăng ký sự kiện khi thưởng/phạt thay đổi

    Base.app.off('onThuongPhatChanged');
    Base.app.on('onThuongPhatChanged', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.calculate();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()); //Đăng ký sự kiện khi tạm ứng thay đổi

    Base.app.off('onTamUngChanged');
    Base.app.on('onTamUngChanged', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.calculate();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  },
  //Sau khi chọn nhân viên
  //Lấy dữ liệu thu nhập
  getdata: function () {
    var _getdata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var month, year, id_emp, loading, rs;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(Employee.currentRow == null)) {
                _context3.next = 3;
                break;
              }

              Utils.errorDialog('Chưa chọn cán bộ');
              return _context3.abrupt("return", false);

            case 3:
              $(this.pn + ' ul.income-master-form').removeClass('display-none');
              this.reset();
              month = $(this.pn + ' select[name="month"]').val();
              year = $(this.pn + ' input[name="year"]').val();
              this.selectedMonth = month;
              this.selectedYear = year;
              id_emp = Employee.currentRow.id;
              loading = Base.app.dialog.preloader('Đang tải');
              _context3.next = 13;
              return Base.api('Income', 'getdata', {
                month: month,
                year: year,
                id_emp: id_emp
              });

            case 13:
              rs = _context3.sent;
              loading.close();
              Employee.incomeRow = rs.row; //Set lương cứng

              Employee.incomeRow.luong_cung = Employee.currentRow.salary;
              this.calculate();

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getdata() {
      return _getdata.apply(this, arguments);
    }

    return getdata;
  }(),
  //Điền dữ liệu vào form
  fillFromData: function fillFromData() {
    var row = Employee.incomeRow; //income row

    var checked = parseInt(row.confirmed) == 1 ? true : false;
    $(this.pn + ' input[name="confirmed"]').prop("checked", checked);

    for (var field in row) {
      $(this.pn + " input[name=\"".concat(field, "\"]")).val(row[field] || 0);
      $(this.pn + " span[data-field=\"".concat(field, "\"]")).text(row[field] || 0);
    } //Hiển thị số được format cho các field có thể điền


    $(this.pn + ' input.autonumeric').each(function () {
      AutoNumeric.set(this, row[$(this).attr('name')] || 0);
    }); //Format lại số để hiển thị

    $(this.pn + ' span.data-field').each(function () {
      var value = Utils.num2Str($(this).text());
      $(this).text(value);
    });
  },
  initSoCongDu: function initSoCongDu() {
    var month = $(this.pn + ' select[name="month"]').val();
    var year = $(this.pn + ' input[name="year"]').val();
    var ymd = "".concat(year, "-").concat(month.length === 2 ? month : '0' + month, "-01");
    var so_ngay = moment(ymd).daysInMonth();
    $(this.pn + ' input[name="so_ngay"]').val(so_ngay);
    var so_cong_du = so_ngay - 1;
    $(this.pn + ' input[name="so_cong_du"]').val(so_cong_du);
    return so_cong_du;
  },
  reset: function reset() {
    $(this.pn + ' input.autonumeric').val('');
    $(this.pn + ' span.data-field').text('0');
    $(this.pn + ' input[name="so_cong_thuc"]').val('');
    this.initSoCongDu();
    $(this.pn + ' input[name="confirmed"]').prop("checked", false);
  },
  save: function () {
    var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var data, field, thang_nam, loader, rs;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              //Lấy dữ liệu có trong form
              data = Base.app.form.convertToData($(this.pn + ' ul.income-master-form'));
              data.confirmed = null;

              if ($(this.pn + ' input[name="confirmed"]').prop("checked")) {
                data.confirmed = 1;
                Employee.incomeRow.confirmed = 1;
              } //Chuyển dữ liệu dạng formated thành chuỗi bình thường để submit


              _context4.t0 = _regeneratorRuntime.keys(data);

            case 4:
              if ((_context4.t1 = _context4.t0()).done) {
                _context4.next = 11;
                break;
              }

              field = _context4.t1.value;

              if (!(field == 'so_cong_thuc')) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("continue", 4);

            case 8:
              data[field] = Utils.str2Num(data[field]);
              _context4.next = 4;
              break;

            case 11:
              data.so_cong_thuc = data.so_cong_thuc || 0; //Lấy dữ liệu tháng / năm

              thang_nam = Base.app.form.convertToData($(this.pn + ' ul.thangnam-form'));
              data.id_emp = Employee.incomeRow.id_emp;
              data.thang = thang_nam.month;
              data.nam = thang_nam.year;
              loader = Base.app.dialog.preloader('Đang lưu...');
              _context4.next = 19;
              return Base.api('Income', 'save', data);

            case 19:
              rs = _context4.sent;
              loader.close();

              if (!rs.result) {
                _context4.next = 24;
                break;
              }

              Utils.notiInfo('Lưu lại thành công');
              return _context4.abrupt("return", rs.data_row);

            case 24:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function save() {
      return _save.apply(this, arguments);
    }

    return save;
  }(),
  calculate: function calculate() {
    var row = Employee.incomeRow; //income row

    row.luong_cung = row.luong_cung || 0;
    row.luong_du_cong = row.luong_cung + row.thuong_doanh_so + row.thuong_dung_gio + row.thuong_chuyen_can;
    if (row.so_cong_du == null || row.so_cong_du == 0) row.so_cong_du = this.initSoCongDu();
    row.luong_thuc_cong = parseInt(row.luong_du_cong / row.so_cong_du * row.so_cong_thuc);
    row.luong_thuc_cong = Utils.roundUp(row.luong_thuc_cong, 10000);
    row.tong_thu = row.luong_thuc_cong + row.thuong_phat + row.cac_khoan_khac;
    row.thuc_nhan = row.tong_thu - (row.tam_ung + row.thue_nha + row.dien_nuoc); //Điền dữ liệu vào form

    this.fillFromData(); //Cập nhật dữ liệu

    this.save();
  }
};
export default (function (props, ctx) {
  ctx.$on('page:init', function () {
    Income.init();
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="income">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
      <div class="title sliding">Chốt lương</div>
      <div class="right"><a href="#" @click=${profile} id="login-button"><i class="f7-icons icon">person_circle</i></a></div>
    </div>
  </div>
  <div class="toolbar toolbar-bottom">
    <div class="toolbar-inner">
      <a href="#" class="button" id="income-save-button">Lưu lại</a>
    </div>
  </div>
  <div class="page-content">
    <div class="list no-margin">
      <ul class="thangnam-form">
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-input-wrap input-dropdown">
              <select name="month">
                <option value="1">T1</option>
                <option value="2">T2</option>
                <option value="3">T3</option>
                <option value="4">T4</option>
                <option value="5">T5</option>
                <option value="6">T6</option>
                <option value="7">T7</option>
                <option value="8">T8</option>
                <option value="9">T9</option>
                <option value="10">T10</option>
                <option value="11">T11</option>
                <option value="12">T12</option>
              </select>
            </div>
          </div>
          <div class="item-inner">
            <div class="item-input-wrap">
              <input type="text" pattern="[0-9]*" name="year"/>
            </div>
          </div>
          <div class="item-inner">
            <a href="/employee-list-popup/selectEmpForIncome" class="button">Chọn</a>
          </div>
          <div class="item-inner emp-name">
            -
          </div>
        </li>
      </ul>
    </div>
    <div class="list no-margin">
      <ul class="income-master-form display-none">
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label">Số công thực</div>
            <div class="item-input-wrap">
              <input type="text" name="so_cong_thuc" class="recalculate" placeholder="0"/>
            </div>
          </div>
          <div class="item-inner">
            <div class="item-label">Số công đủ</div>
            <div class="item-input-wrap">
              <input type="text" name="so_cong_du" class="recalculate" placeholder="0"/>
            </div>
          </div>
          <div class="item-inner">
            <div class="item-label">Số ngày</div>
            <div class="item-input-wrap">
              <input type="text" name="so_ngay" readonly/>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label">Lương cứng</div>
            <div class="item-input-wrap">
              <input type="text" name="luong_cung" class="autonumeric recalculate" placeholder="0"/>
            </div>
          </div>
          <div class="item-inner">
            <div class="item-label text-color-green">Thưởng doanh số</div>
            <div class="item-input-wrap">
              <input type="text" name="thuong_doanh_so" class="autonumeric recalculate" placeholder="0"/>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label text-color-green">Thưởng đúng giờ</div>
            <div class="item-input-wrap">
              <input type="text" name="thuong_dung_gio" class="autonumeric recalculate" placeholder="0"/>
            </div>
          </div>
          <div class="item-inner">
            <div class="item-label text-color-green">Thưởng chuyên cần</div>
            <div class="item-input-wrap">
              <input type="text" name="thuong_chuyen_can" class="autonumeric recalculate" placeholder="0"/>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label text-color-green">Lương thực công</div>
            <div class="item-input-wrap">
              <span data-field="luong_thuc_cong" class="data-field">0</span>
              <input type="hidden" name="luong_thuc_cong" value="0"/>
            </div>
          </div>
          <div class="item-inner">
            <div class="item-label">Lương đủ công</div>
            <div class="item-input-wrap">
              <span data-field="luong_du_cong" class="data-field">0</span>
              <input type="hidden" name="luong_du_cong" value="0"/>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label"><span class="text-color-green">Thưởng</span>/<span class="text-color-red">Phạt</span></div>
            <div class="item-input-wrap">
              <span data-field="thuong_phat" class="data-field">0</span>
              <input type="hidden" name="thuong_phat" value="0"/>
            </div>
          </div>
          <div class="item-inner">
            <a href="/income-bonus-popup/" class="button">Chi tiết</a>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label text-color-green">Các khoản khác</div>
            <div class="item-input-wrap">
              <input type="text" name="cac_khoan_khac" class="cac_khoan_khac autonumeric recalculate" placeholder="0"/>
            </div>
          </div>
          <div class="item-inner">
            <div class="item-label">Tổng thu</div>
            <span data-field="tong_thu" class="data-field text-color-orange text-bold">0</span>
            <input type="hidden" name="tong_thu" value="0"/>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label text-color-red">Đã tạm ứng</div>
            <div class="item-input-wrap">
              <span data-field="tam_ung" class="data-field">0</span>
              <input type="hidden" name="tam_ung" value="0"/>
            </div>
          </div>
          <div class="item-inner">
            <a href="/income-tamung-popup/" class="button">Chi tiết</a>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label text-color-red">Thuê nhà</div>
            <div class="item-input-wrap">
              <input type="text" name="thue_nha" class="thue_nha autonumeric recalculate" placeholder="0"/>
            </div>
          </div>
          <div class="item-inner">
            <div class="item-label text-color-red">Điện nước</div>
            <div class="item-input-wrap">
              <input type="text" name="dien_nuoc" class="dien_nuoc autonumeric recalculate" placeholder="0"/>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label">Thực nhận</div>
            <div class="item-input-wrap">
              <span data-field="thuc_nhan" class="data-field text-color-green text-bold">0</span>
              <input type="hidden" name="thuc_nhan" value="0"/>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <p>Xác nhận (hiển thị cho cán bộ) <label class="checkbox"><input type="checkbox" value="1" name="confirmed" /><i class="icon-checkbox"></i></label></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
`
    }
    ;
});